import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Slider from '@material-ui/core/Slider';
import Typography from '@material-ui/core/Typography';

//https://github.com/mui-org/material-ui/blob/master/packages/material-ui/src/Slider/Slider.js
const styles = {
  root: {
    width: '100%',
    margin: '2em .5em',
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    padding: '0',
  },
  typography: {
    fontFamily: 'inherit',
    fontSize: '1.6rem',
    position: 'absolute',
    top: '-2.5em',
    right: '0',
    color: '#000',
  },

  slider: {
    // color: '#30A3B0',
    color: '#bbb',
  },

  rail: {
    height: 6,
    borderRadius: 10,
    color: 'rgb(0, 189, 181)',
    opacity: '.21',
  },
  track: {
    height: 6,
    borderRadius: 10,
    color: '#000',
  },
  // trackInverted: {
  //   borderRadius: 10,
  // },
  mark: {
    height: 5.5,
    width: 5.5,
    borderRadius: '50%',
    color: 'rgb(0, 189, 181)',
  },
  markActive: {
    backgroundColor: 'rgb(193, 237, 230)',
  },
  markLabel: {
    // color: 'red',
  },
  thumb: {
    marginTop: '0',
    color: '#000',

    height: '16px',
    width: '16px',
    '&$focusVisible,&:hover': {
      boxShadow: `0px 0px 0px 8px rgba(0, 0, 0, .1)`,
    },
  },
  valueLabel: {
    color: 'rgba(0, 0, 0, .1)',
    left: 'calc(-50%)',
    '& span': {
      '& span': {
        color: '#000',
        fontWeight: 'bold',
        fontSize: '1.2em',
      },
    },
  },
};

function valuetext(value) {
  return `${value}`;
}

class StepSlider extends Component {
  handleChange = (event, value) => {
    this.props.onChange(value);
  };
  classes = this.props.classes;

  render() {
    return (
      <div className={this.classes.root}>
        <Typography
          id="discrete-slider"
          gutterBottom
          className={this.classes.typography}
        >
          {this.props.title}
        </Typography>
        <Slider
          className={this.classes.slider}
          value={this.props.value}
          defaultValue={1}
          getAriaValueText={valuetext}
          aria-labelledby="discrete-slider"
          valueLabelDisplay="auto"
          step={this.props.step}
          marks
          min={this.props.min}
          max={this.props.max}
          onChange={this.handleChange}
        />
      </div>
    );
  }
}

StepSlider.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles, { name: 'MuiSlider' })(StepSlider);
